// Override manually, because there's a window.Clipboard function in some browsers
import clipboard from 'clipboard';
window.Clipboard = clipboard;

import 'expose-loader?exposes=$,jQuery!jquery';
import 'expose-loader?exposes=ko!knockout';
import 'expose-loader?exposes=store!store';
import 'expose-loader?exposes=io!socket.io-client';
import 'expose-loader?exposes=moment!moment';

import 'jquery-touch-events/src/jquery.mobile-events';
import 'knockout-postbox';
ko.options.deferUpdates = true;
ko.postbox.serializer = function (value) { return value; };

import 'knockout.validation';
ko.validation.init({ insertMessages: false });

import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab';
